import { Component } from '@angular/core';

import { SkyModalInstance } from '../../core';

import { SkyFilterDemoModalContext } from './filter-demo-modal-context';


export class SkyFilterDemoModalComponent {
  public fruitType = 'any';
  public hideOrange: boolean;

  constructor(
    public context: SkyFilterDemoModalContext,
    public instance: SkyModalInstance
  ) {
    if (
      this.context &&
      this.context.appliedFilters &&
      this.context.appliedFilters.length > 0
    ) {
      this.setFormFilters(this.context.appliedFilters);
    } else {
      this.clearAllFilters();
    }
  }

  public applyFilters() {
    let result = this.getAppliedFiltersArray();
    this.instance.save(result);
  }

  public clearAllFilters() {
    this.hideOrange = false;
    this.fruitType = 'any';
  }

  public cancel() {
    this.instance.cancel();
  }

  private getAppliedFiltersArray() {
    let appliedFilters: any[] = [];
    if (this.fruitType !== 'any') {
      appliedFilters.push({
        name: 'fruitType',
        value: this.fruitType,
        label: this.fruitType
      });
    }

    if (this.hideOrange) {
      appliedFilters.push({
        name: 'hideOrange',
        value: true,
        label: 'hide orange fruits'
      });
    }

    return appliedFilters;
  }

  private setFormFilters(appliedFilters: any[]) {
    for (let i = 0; i < appliedFilters.length; i++) {
      if (appliedFilters[i].name === 'fruitType') {
        this.fruitType = appliedFilters[i].value;
      }

      if (appliedFilters[i].name === 'hideOrange') {
        this.hideOrange = appliedFilters[i].value;
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-demo-filter-modal-form',
  template: `<sky-modal>
  <sky-modal-header>
    Food preferences
  </sky-modal-header>
  <sky-modal-content>
    <label for="sky-demo-select-type">Fruit type</label>
    <select id="sky-demo-select-type" [(ngModel)]="fruitType" class="sky-form-control">
      <option value="any">Any fruit</option>
      <option value="citrus">Citrus</option>
      <option value="berry">Berry</option>
    </select>
    <div style="margin-top: 15px;">
      <sky-checkbox [(ngModel)]="hideOrange">
        <sky-checkbox-label>
          Hide orange fruits
        </sky-checkbox-label>
      </sky-checkbox>
    </div>
  </sky-modal-content>
  <sky-modal-footer>
    <button
      type="button"
      class="sky-btn sky-btn-primary"
      (click)="applyFilters()">
      Apply filters
    </button>
    <button
      type="button"
      class="sky-btn sky-btn-link"
      (click)="clearAllFilters()">
      Clear all filters
    </button>
    <button
      type="button"
      class="sky-btn sky-btn-link"
      (click)="cancel()">
      Cancel
    </button>
  </sky-modal-footer>
</sky-modal>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyFilterDemoModalContext, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
